export const FALLBACK_MAP_CENTER = {
    lat: 50.075538, // Prague latitude (fallback)
    lng: 14.437802, // Prague longitude (fallback)
};

export const SNAP_DISTANCE_IN_METERS = 200;
